import React from 'react';

const NavIcon = ({ name }) => {
  const icons = {
    pulse: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><polyline points="1,8 4,8 5,3 7,13 9,5 11,10 12,8 15,8"/></svg>,
    agents: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="5" r="2.5"/><path d="M3 14c0-2.76 2.24-5 5-5s5 2.24 5 5"/></svg>,
    chat: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M14 9a2 2 0 01-2 2H6l-3 3V4a2 2 0 012-2h7a2 2 0 012 2z"/></svg>,
    approval: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="12" height="12" rx="2"/><polyline points="5,8 7,10 11,6"/></svg>,
    escalation: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M8 2L8 9M8 11L8 13"/><path d="M2 14L8 2L14 14H2Z"/></svg>,
    studio: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="8" r="6"/><polygon points="6,5 12,8 6,11" fill="currentColor" stroke="none"/></svg>,
    ambassadors: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="5" cy="5" r="2"/><circle cx="11" cy="5" r="2"/><path d="M1 14c0-2.2 1.8-4 4-4s4 1.8 4 4"/><path d="M9 14c0-2.2 1.8-4 4-4" opacity="0.5"/></svg>,
    launchpad: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M8 1c2 2 3 4 3 7H5c0-3 1-5 3-7z"/><path d="M5 8v4l3 2 3-2V8"/></svg>,
  };
  return <span className="nav-icon" style={{display:'flex',alignItems:'center',width:'14px',height:'14px'}}>{icons[name]}</span>;
};

export default function Sidebar({ page, setPage }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="sidebar-logo-title">⌘ Command Center</div>
        <div className="sidebar-logo-sub">Meduvita · My Medicine Friend</div>
      </div>

      <div className="sidebar-section-label">Overview</div>
      <div className={`sidebar-nav-item ${page==='dashboard'?'active':''}`} onClick={()=>setPage('dashboard')}><NavIcon name="pulse"/>Morning Pulse</div>

      <div className="sidebar-section-label">Operations</div>
      <div className={`sidebar-nav-item ${page==='agents'?'active':''}`} onClick={()=>setPage('agents')}><NavIcon name="agents"/>AI Agents</div>
      <div className={`sidebar-nav-item ${page==='chat'?'active':''}`} onClick={()=>setPage('chat')}><NavIcon name="chat"/>Chat with Agents<span style={{marginLeft:'auto',fontSize:'9px',background:'var(--accent-m-dim)',color:'var(--accent-m)',padding:'1px 5px',borderRadius:'4px',border:'1px solid rgba(0,212,170,0.2)'}}>NEW</span></div>
      <div className={`sidebar-nav-item ${page==='approval'?'active':''}`} onClick={()=>setPage('approval')}><NavIcon name="approval"/>Approval Queue</div>
      <div className={`sidebar-nav-item ${page==='escalations'?'active':''}`} onClick={()=>setPage('escalations')}><NavIcon name="escalation"/>Escalations</div>

      <div className="sidebar-section-label">Growth</div>
      <div className={`sidebar-nav-item ${page==='studio'?'active':''}`} onClick={()=>setPage('studio')}><NavIcon name="studio"/>Studio Panel</div>
      <div className={`sidebar-nav-item ${page==='ambassadors'?'active':''}`} onClick={()=>setPage('ambassadors')}><NavIcon name="ambassadors"/>Ambassadors</div>

      <div className="sidebar-section-label">Launch</div>
      <div className={`sidebar-nav-item ${page==='launchpad'?'active':''}`} onClick={()=>setPage('launchpad')}><NavIcon name="launchpad"/>Launchpad</div>

      <div className="sidebar-status">
        <div style={{fontSize:'11px',color:'var(--text-3)'}}>
          <span className="status-dot"/>All systems operational
        </div>
        <div style={{fontSize:'10px',color:'var(--text-3)',marginTop:'4px',paddingLeft:'15px'}}>11 agents · £0/mo</div>
      </div>
    </aside>
  );
}
